import React, { useState, useEffect } from "react";
import { URL } from "../../api";
import moneyPic from "../../assets/img/money.png";
import eyePic from "../../assets/img/eye.png";
import Topup from "./Topup";
import AadharXml from "./AadharXml";
import axiosInstance from "../../Request";
import { useLocation } from "react-router-dom";
import { Button, Container, Row, Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  Input
} from "reactstrap";

const UserHeader = ({ cid, lid }) => {
  const location = useLocation();
  const [headerDetails, setCustomerDetails] = useState(null);
  // All of this customer's loans, for the "View Loan" switcher. Selecting one switches the whole detail
  // page to that loan's lead so every per-loan section (documents, SOA, installments) follows it.
  const [loans, setLoans] = useState([]);
  const switchLoan = (newLeadId) => {
    if (!newLeadId || String(newLeadId) === String(lid)) return;
    const parts = location.pathname.split("/").map((s) => (s === String(lid) ? String(newLeadId) : s));
    // Full reload (not SPA navigate) so EVERY section re-fetches for the newly selected loan — several
    // detail sections fetch only on mount and would otherwise keep showing the previous loan.
    window.location.assign(parts.join("/"));
  };
    const [topUpModal, setTopUpModal] = useState(false);
const [formData, setFormData] = useState({
  amount: "",
  roi: "",
  processingFee: "",
  tenure: "",
});

const [showErrorModal, setShowErrorModal] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

const [aadharModalOpen, setAadharModalOpen] = useState(false);
const toggleAadharModal = () => setAadharModalOpen(!aadharModalOpen);

const [noOkycModal, setNoOkycModal] = useState(false);



useEffect(() => {
  const fetchCustomerHeaderDetails = async () => {
    try {
      const response = await axiosInstance.get(URL.CUSTOMER_HEADER_DETAILS + `?customer_id=${cid}&loan_id=${lid}`);
      const data = response.data;
      setCustomerDetails(data);
    } catch (error) {
      console.error("Error fetching customer details:", error);
      const errorMsg = error?.response?.data?.message || "Customer not found";
      setErrorMessage(errorMsg);
      setShowErrorModal(true);
    }
  };

  fetchCustomerHeaderDetails();
}, [cid, lid]);

useEffect(() => {
  if (!cid) return;
  axiosInstance
    .get(URL.LEAD_LIST, { params: { customer_id: cid } })
    .then((r) => setLoans((Array.isArray(r.data) ? r.data : []).filter((x) => x.loan_code)))
    .catch(() => setLoans([]));
}, [cid]);

  
    useEffect(() => {
  if (showErrorModal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }

  return () => {
    document.body.style.overflow = 'auto';
  };
}, [showErrorModal]);


    const toggleTopUpModal = () => setTopUpModal(!topUpModal);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTopUpSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Top Up:", formData);
    toggleTopUpModal();
    // You can add API submission logic here
  };

  return (
    
            <>
            <AadharXml isOpen={aadharModalOpen} toggle={toggleAadharModal} customerId={cid} />
              <Modal
          isOpen={noOkycModal}
          toggle={() => setNoOkycModal(false)}
          centered
          style={{ marginTop: "-40px" }}
        >
          <ModalBody className="d-flex justify-content-between align-items-center">
            <span>No OKYC found for this customer.</span>
            <button
              onClick={() => setNoOkycModal(false)}
              style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer" }}
            >
            </button>
          </ModalBody>
        </Modal>

      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "300px",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        <span className="mask bg-gradient-default opacity-8" />
        <Container className="d-flex align-items-center" fluid>
          <Row style={{ width: "100%" }}>
            <Col md="12">
              <Card className="bg-secondary shadow">
                <CardBody>
                {loans.length > 1 && (
                  <Row className="mb-3">
                    <Col md="12" className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <span className="font-weight-bold" style={{ whiteSpace: "nowrap" }}>View Loan:</span>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={String(lid)}
                        onChange={(e) => switchLoan(e.target.value)}
                        style={{ maxWidth: "340px" }}
                      >
                        {loans.map((l) => (
                          <option key={l.lead_id} value={String(l.lead_id)}>
                            {(l.loan_code || `Loan #${l.lead_id}`) +
                              (l.disbursed_amount != null
                                ? ` — ₹${Number(l.disbursed_amount).toLocaleString("en-IN")}`
                                : "")}
                          </option>
                        ))}
                      </Input>
                      <span className="text-muted small">switch to view this loan's documents &amp; details</span>
                    </Col>
                  </Row>
                )}
                <Row>
                <Col md="3">
                  <div className="header-profile-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="Profile"
                        className="rounded-circle"
                        src={
                          headerDetails?.profilePic === '-NA-' ?
                          require("../../assets/img/default_user.jpg")
                            :
                          headerDetails?.profilePic
                        }
                        style={{ width: "200px", height: "200px", objectFit: "cover" }}
                      />
                    </a>
                  </div>
                </Col>
                           
                  <Col md="5">

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Name
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.headerInfo?.borrowerName ?? "-NA-"}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        customer id
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.customerCode ?? headerDetails?.headerInfo?.customerId ?? "-NA-"}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Loan Code
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.loanCode ?? "-NA-"}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Lead Code
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.leadCode ?? "-NA-"}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Application ID
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.headerInfo?.applicationId ?? "-NA-"}
                        </Col>
                      </Row>
                  </Col>

                  <Col md="3">

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Customer Status
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.headerInfo?.customerStatusValue ?? "-NA-"}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Lead Status
                        </Col>
                        <Col md="6" className="label_t2">
                          {headerDetails?.headerInfo?.leadStatusValue ?? "-NA-"}
                        </Col>
                      </Row>

                  
                      <Row className="mb-2">
                        <Col md="6" className="label_t1">
                        Product Code
                        </Col>
                        <Col md="6" className="label_t2">
                        {headerDetails?.headerInfo?.productName ?? "-NA-"}
                        </Col>
                      </Row>

                  <Topup
                    isOpen={topUpModal}
                    toggle={toggleTopUpModal}
                    formData={formData}
                    handleChange={handleInputChange}
                    handleSubmit={handleTopUpSubmit}
                  />

                  </Col>
                  <Col md="1" className="ms-auto d-flex flex-column align-items-end">
                    <img
                      src={moneyPic}
                      alt="Money Icon"
                      style={{ width: "28px", height: "28px", cursor: "pointer", marginBottom: "8px" }}
                      onClick={toggleTopUpModal}
                    />
                    <img
                    src={eyePic}
                    alt="Eye Icon"
                    style={{ width: "28px", height: "28px", cursor: "pointer" }}
                    onClick={async () => {
                    try {
                      const res = await axiosInstance.get(`${URL.GET_DOCUMENT_AADHAR}?customer_id=${cid}`);
                      const data = res.data;
                      if (data && data.uid) {
                        setAadharModalOpen(true);
                      } else {
                        setNoOkycModal(true); // Open modal
                      }
                    } catch (err) {
                      setNoOkycModal(true); // Also show modal on error
                    }
                  }}
                  />
                  </Col>
                  </Row>
            </CardBody>
                </Card>
                </Col>
                </Row>
                </Container>
                </div>
                {showErrorModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "30px 40px",
                  borderRadius: "12px",
                  maxWidth: "400px",
                  textAlign: "center",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.4)",
                }}
              >
                <h4 style={{ marginBottom: "20px" }}>Customer Not Found</h4>
                <p>{errorMessage}</p>
              </div>
            </div>
          )}

              </>
            );
          };

export default UserHeader;
